module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<html lang=\"de\">\n<head>\n<style>\nbody {\nfont-family: Arial, Helvetica, sans-serif;\ncolor: #333333;\ntext-align: center;\npadding-top: 10%;\n}\nh1 {\nfont-size: 28px;\n}\np {\nfont-size: 16px;\n}\na.button {\nmargin-top: 15px;\ntext-align: center;\npadding: 10px 20px;\nbackground-color: #666666;\ncolor: #FFFFFF;\ntext-decoration: none;\nborder: 1px solid #666666;\n}\na.button:hover {\nbackground-color: #FFFFFF;\ncolor: #666666;\n}\n</style>\n</head>\n<body>\n<h1>Vom Newsletter abmelden</h1>\n<p>Bitte bestätigen Sie Ihre Abmeldung von unserem Newsletter mit einem Klick auf den Button:<br><br></p>\n<p><a class=\"button\" href=\"<%= model.unsubscribeLink %>\">Abmeldung jetzt bestätigen</a></p>\n</body>\n</html>"
  , __filename = "node_modules/frontend-controller/baseComponents/newsletter/unsubscribeConfirm.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<html lang=\"de\">\n<head>\n<style>\nbody {\nfont-family: Arial, Helvetica, sans-serif;\ncolor: #333333;\ntext-align: center;\npadding-top: 10%;\n}\nh1 {\nfont-size: 28px;\n}\np {\nfont-size: 16px;\n}\na.button {\nmargin-top: 15px;\ntext-align: center;\npadding: 10px 20px;\nbackground-color: #666666;\ncolor: #FFFFFF;\ntext-decoration: none;\nborder: 1px solid #666666;\n}\na.button:hover {\nbackground-color: #FFFFFF;\ncolor: #666666;\n}\n</style>\n</head>\n<body>\n<h1>Vom Newsletter abmelden</h1>\n<p>Bitte bestätigen Sie Ihre Abmeldung von unserem Newsletter mit einem Klick auf den Button:<br><br></p>\n<p><a class=\"button\" href=\"")
    ; __line = 34
    ; __append(escapeFn( model.unsubscribeLink ))
    ; __append("\">Abmeldung jetzt bestätigen</a></p>\n</body>\n</html>")
    ; __line = 36
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/newsletter/unsubscribeConfirm.ejs

}